// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sensors-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.92893 4.92871C3.11929 6.73835 2 9.23835 2 11.9998C2 14.7613 3.11933 17.2613 4.92904 19.071M7.75736 7.75684C6.67157 8.84262 6 10.3426 6 11.9995C6 13.6564 6.67162 15.1564 7.75747 16.2422M12 10V14M16.2423 7.75684C17.3281 8.84262 17.9997 10.3426 17.9997 11.9995C17.9997 13.6564 17.328 15.1564 16.2422 16.2422M19.0714 4.92871C20.881 6.73835 22.0003 9.23835 22.0003 11.9998C22.0003 14.7613 20.881 17.2613 19.0713 19.071","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Sensors2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sensors-2',
    ref,
    icon: element,
  },
));

Sensors2Icon.displayName = 'Sensors2Icon';

export default Sensors2Icon;
